import * as angular from 'angular';
declare var Appcues: any;

export class AppCueService {
    static $inject = ['$rootScope'];

    constructor(
        private $rootScope: ng.IRootScopeService
    ) {
        $rootScope.$on('$locationChangeSuccess', function() {
            if (Appcues) {
                Appcues.page();
            }
        });
    }

    public setUserData(userId: string) {
        if (Appcues && userId) {
            Appcues.identify(userId, {});
        } else {
            console.log('User haven\'t id');
        }
    }

    public resetUserData() {
        if (Appcues) {
            Appcues.reset();
        }
    }
}

angular.module('app.common').service('appCueService', AppCueService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/appcue.service.ts